import { createFileRoute, redirect } from '@tanstack/react-router'
import { AppRoute } from 'appRoutes'
import {
  deduplicateModelVersionPages,
  FraudAnalysisUnconfiguredModelPage,
  fraudScoreLabelDefinitionsQueryOptions,
  fraudScoreModelsQueryOptions,
  fraudScoreModelVersionsQueryOptions,
  getDefaultModelVersionId,
} from 'features/fraudAnalysis'

export const Route = createFileRoute(
  '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/overview'
)({
  component: FraudAnalysisUnconfiguredModelPage,
  loader: async ({
    context: { queryClient, buildRequest, fraudScoreEntitlement },
    params: { subscriptionId, labelSlug, clientType },
  }) => {
    if (fraudScoreEntitlement === 'disabled') {
      return
    }

    const labelDefinitions = await queryClient.ensureQueryData(
      fraudScoreLabelDefinitionsQueryOptions(buildRequest, subscriptionId)
    )
    const label = labelDefinitions.find((definition) => definition.labelSlug === labelSlug)

    if (label && label.category == null) {
      return
    }

    const models = await queryClient.ensureInfiniteQueryData(
      fraudScoreModelsQueryOptions(buildRequest, subscriptionId, { labelSlug, clientType })
    )
    const model = models.pages.flatMap((page) => page.data)[0]
    let modelVersionId = getDefaultModelVersionId(model)

    if (!modelVersionId && model?.latestTrainedVersion) {
      const versions = await queryClient.ensureInfiniteQueryData(
        fraudScoreModelVersionsQueryOptions(buildRequest, subscriptionId, labelSlug, clientType)
      )
      modelVersionId = getDefaultModelVersionId(model, deduplicateModelVersionPages(versions.pages))
    }

    if (modelVersionId) {
      throw redirect({
        to: AppRoute.FraudAnalysisModelVersionOverview,
        params: { subscriptionId, labelSlug, clientType, modelVersionId },
        replace: true,
      })
    }

    throw redirect({
      to: AppRoute.FraudAnalysisModelDetailsVersions,
      params: { subscriptionId, labelSlug, clientType },
      replace: true,
    })
  },
})
